import React, { useState } from 'react';
import { BarChart2, Calendar, ChevronLeft, Download, FileText, Filter, Printer, RefreshCw, Users, CheckSquare, Clock, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ReportGenerator() {
  const [reportType, setReportType] = useState('committee');
  const [dateRange, setDateRange] = useState('last30');
  const [selectedCommittees, setSelectedCommittees] = useState<string[]>(['all']);
  const [selectedStatus, setSelectedStatus] = useState<string[]>(['all']);
  const [isGenerating, setIsGenerating] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const committees = [{
    id: 'finance',
    name: 'Finance Committee'
  }, {
    id: 'hr',
    name: 'HR Committee'
  }, {
    id: 'it',
    name: 'IT Committee'
  }, {
    id: 'procurement',
    name: 'Procurement Committee'
  }, {
    id: 'quality',
    name: 'Quality Assurance Committee'
  }];
  const statusOptions = [{
    id: 'active',
    name: 'Active'
  }, {
    id: 'completed',
    name: 'Completed'
  }, {
    id: 'pending',
    name: 'Pending'
  }, {
    id: 'delayed',
    name: 'Delayed'
  }];
  const handleCommitteeChange = (committeeId: string) => {
    if (committeeId === 'all') {
      setSelectedCommittees(['all']);
    } else {
      const newSelection = selectedCommittees.includes('all') ? [committeeId] : selectedCommittees.includes(committeeId) ? selectedCommittees.filter(id => id !== committeeId) : [...selectedCommittees, committeeId];
      setSelectedCommittees(newSelection.length ? newSelection : ['all']);
    }
  };
  const handleStatusChange = (statusId: string) => {
    if (statusId === 'all') {
      setSelectedStatus(['all']);
    } else {
      const newSelection = selectedStatus.includes('all') ? [statusId] : selectedStatus.includes(statusId) ? selectedStatus.filter(id => id !== statusId) : [...selectedStatus, statusId];
      setSelectedStatus(newSelection.length ? newSelection : ['all']);
    }
  };
  const generateReport = () => {
    setIsGenerating(true);
    // Simulate report generation
    setTimeout(() => {
      setIsGenerating(false);
      setReportGenerated(true);
    }, 2000);
  };
  return <div data-id="element-1593">
      <div className="flex items-center mb-6" data-id="element-1594">
        <Link to="/reports" className="flex items-center text-gray-600 hover:text-gray-900 mr-4" data-id="element-1595">
          <ChevronLeft size={20} className="mr-1" data-id="element-1596" />
          Back to Reports
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1597">Generate Report</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1598">
        {/* Report Configuration */}
        <div data-id="element-1599">
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1600">
            <h2 className="text-lg font-semibold mb-4" data-id="element-1601">Report Configuration</h2>
            <div className="space-y-6" data-id="element-1602">
              {/* Report Type */}
              <div data-id="element-1603">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1604">
                  Report Type
                </label>
                <div className="space-y-2" data-id="element-1605">
                  <label className="flex items-center" data-id="element-1606">
                    <input type="radio" name="reportType" value="committee" checked={reportType === 'committee'} onChange={() => setReportType('committee')} className="mr-2" data-id="element-1607" />
                    <Users size={16} className="mr-2 text-blue-500" data-id="element-1608" />
                    Committee Performance Report
                  </label>
                  <label className="flex items-center" data-id="element-1609">
                    <input type="radio" name="reportType" value="task" checked={reportType === 'task'} onChange={() => setReportType('task')} className="mr-2" data-id="element-1610" />
                    <CheckSquare size={16} className="mr-2 text-orange-500" data-id="element-1611" />
                    Task Completion Report
                  </label>
                  <label className="flex items-center" data-id="element-1612">
                    <input type="radio" name="reportType" value="meeting" checked={reportType === 'meeting'} onChange={() => setReportType('meeting')} className="mr-2" data-id="element-1613" />
                    <Calendar size={16} className="mr-2 text-purple-500" data-id="element-1614" />
                    Meeting Attendance Report
                  </label>
                  <label className="flex items-center" data-id="element-1615">
                    <input type="radio" name="reportType" value="custom" checked={reportType === 'custom'} onChange={() => setReportType('custom')} className="mr-2" data-id="element-1616" />
                    <FileText size={16} className="mr-2 text-green-500" data-id="element-1617" />
                    Custom Report
                  </label>
                </div>
              </div>
              {/* Date Range */}
              <div data-id="element-1618">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1619">
                  Date Range
                </label>
                <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-1620">
                  <option value="last7" data-id="element-1621">Last 7 days</option>
                  <option value="last30" data-id="element-1622">Last 30 days</option>
                  <option value="last90" data-id="element-1623">Last 90 days</option>
                  <option value="year" data-id="element-1624">This year</option>
                  <option value="custom" data-id="element-1625">Custom range</option>
                </select>
              </div>
              {dateRange === 'custom' && <div className="grid grid-cols-2 gap-4" data-id="element-1626">
                  <div data-id="element-1627">
                    <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1628">
                      Start Date
                    </label>
                    <input type="date" id="startDate" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1629" />
                  </div>
                  <div data-id="element-1630">
                    <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1631">
                      End Date
                    </label>
                    <input type="date" id="endDate" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1632" />
                  </div>
                </div>}
              {/* Committees Filter */}
              <div data-id="element-1633">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1634">
                  Committees
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto" data-id="element-1635">
                  <label className="flex items-center" data-id="element-1636">
                    <input type="checkbox" checked={selectedCommittees.includes('all')} onChange={() => handleCommitteeChange('all')} className="mr-2" data-id="element-1637" />
                    All Committees
                  </label>
                  {committees.map(committee => <label key={committee.id} className="flex items-center" data-id="element-1638">
                      <input type="checkbox" checked={selectedCommittees.includes(committee.id)} onChange={() => handleCommitteeChange(committee.id)} disabled={selectedCommittees.includes('all')} className="mr-2" data-id="element-1639" />
                      {committee.name}
                    </label>)}
                </div>
              </div>
              {/* Status Filter */}
              <div data-id="element-1640">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1641">
                  Status
                </label>
                <div className="space-y-2" data-id="element-1642">
                  <label className="flex items-center" data-id="element-1643">
                    <input type="checkbox" checked={selectedStatus.includes('all')} onChange={() => handleStatusChange('all')} className="mr-2" data-id="element-1644" />
                    All Statuses
                  </label>
                  {statusOptions.map(status => <label key={status.id} className="flex items-center" data-id="element-1645">
                      <input type="checkbox" checked={selectedStatus.includes(status.id)} onChange={() => handleStatusChange(status.id)} disabled={selectedStatus.includes('all')} className="mr-2" data-id="element-1646" />
                      {status.name}
                    </label>)}
                </div>
              </div>
              {/* Generate Button */}
              <div data-id="element-1647">
                <button type="button" className="w-full px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center justify-center" onClick={generateReport} disabled={isGenerating} data-id="element-1648">
                  {isGenerating ? <>
                      <RefreshCw size={18} className="mr-2 animate-spin" data-id="element-1649" />
                      Generating...
                    </> : <>
                      <BarChart2 size={18} className="mr-2" data-id="element-1650" />
                      Generate Report
                    </>}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Report Preview */}
        <div className="lg:col-span-2" data-id="element-1651">
          <div className="bg-white rounded-lg shadow-sm p-6 h-full" data-id="element-1652">
            {!reportGenerated ? <div className="h-full flex flex-col items-center justify-center text-center p-10" data-id="element-1653">
                <BarChart2 size={60} className="text-gray-300 mb-4" data-id="element-1654" />
                <h3 className="text-lg font-medium text-gray-500 mb-2" data-id="element-1655">
                  No Report Generated Yet
                </h3>
                <p className="text-gray-400 mb-6" data-id="element-1656">
                  Configure your report parameters and click "Generate Report"
                  to see results here.
                </p>
                <div className="w-full max-w-md" data-id="element-1657">
                  <div className="h-4 bg-gray-200 rounded mb-3" data-id="element-1658"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" data-id="element-1659"></div>
                  <div className="h-4 bg-gray-200 rounded mb-6" data-id="element-1660"></div>
                  <div className="h-32 bg-gray-100 rounded-lg border border-dashed border-gray-300 flex items-center justify-center" data-id="element-1661">
                    <span className="text-gray-400" data-id="element-1662">
                      Chart preview will appear here
                    </span>
                  </div>
                </div>
              </div> : <div data-id="element-1663">
                <div className="flex justify-between items-center mb-6" data-id="element-1664">
                  <h2 className="text-lg font-semibold" data-id="element-1665">
                    {reportType === 'committee' && 'Committee Performance Report'}
                    {reportType === 'task' && 'Task Completion Report'}
                    {reportType === 'meeting' && 'Meeting Attendance Report'}
                    {reportType === 'custom' && 'Custom Report'}
                  </h2>
                  <div className="flex space-x-2" data-id="element-1666">
                    <button className="p-2 text-gray-500 hover:text-gray-700 border border-gray-300 rounded" data-id="element-1667">
                      <Printer size={18} data-id="element-1668" />
                    </button>
                    <button className="p-2 text-gray-500 hover:text-gray-700 border border-gray-300 rounded" data-id="element-1669">
                      <Download size={18} data-id="element-1670" />
                    </button>
                    <button className="p-2 text-gray-500 hover:text-gray-700 border border-gray-300 rounded" data-id="element-1671">
                      <Filter size={18} data-id="element-1672" />
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-1673">
                  <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-1674">
                    <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1675">
                      Total Committees
                    </h3>
                    <p className="text-2xl font-bold" data-id="element-1676">5</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-1677">
                    <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1678">
                      Task Completion Rate
                    </h3>
                    <p className="text-2xl font-bold" data-id="element-1679">78%</p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg border border-purple-100" data-id="element-1680">
                    <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-1681">
                      Meeting Attendance
                    </h3>
                    <p className="text-2xl font-bold" data-id="element-1682">92%</p>
                  </div>
                </div>
                <div className="mb-6" data-id="element-1683">
                  <h3 className="text-md font-medium mb-3" data-id="element-1684">
                    Performance by Committee
                  </h3>
                  <div className="h-64 bg-gray-50 rounded-lg border border-gray-200 p-4 flex items-center justify-center" data-id="element-1685">
                    <div className="w-full" data-id="element-1686">
                      {/* Mock Bar Chart */}
                      <div className="flex items-end h-40 space-x-6" data-id="element-1687">
                        <div className="flex flex-col items-center" data-id="element-1688">
                          <div className="w-12 bg-blue-500 rounded-t" style={{
                        height: '60%'
                      }} data-id="element-1689"></div>
                          <span className="text-xs mt-1" data-id="element-1690">Finance</span>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-1691">
                          <div className="w-12 bg-blue-500 rounded-t" style={{
                        height: '75%'
                      }} data-id="element-1692"></div>
                          <span className="text-xs mt-1" data-id="element-1693">HR</span>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-1694">
                          <div className="w-12 bg-blue-500 rounded-t" style={{
                        height: '90%'
                      }} data-id="element-1695"></div>
                          <span className="text-xs mt-1" data-id="element-1696">IT</span>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-1697">
                          <div className="w-12 bg-blue-500 rounded-t" style={{
                        height: '45%'
                      }} data-id="element-1698"></div>
                          <span className="text-xs mt-1" data-id="element-1699">Procurement</span>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-1700">
                          <div className="w-12 bg-blue-500 rounded-t" style={{
                        height: '80%'
                      }} data-id="element-1701"></div>
                          <span className="text-xs mt-1" data-id="element-1702">Quality</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1703">
                  <h3 className="text-md font-medium mb-3" data-id="element-1704">
                    Task Status Summary
                  </h3>
                  <div className="overflow-x-auto" data-id="element-1705">
                    <table className="w-full" data-id="element-1706">
                      <thead data-id="element-1707">
                        <tr className="bg-gray-50" data-id="element-1708">
                          <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1709">
                            Committee
                          </th>
                          <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1710">
                            Total Tasks
                          </th>
                          <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1711">
                            Completed
                          </th>
                          <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1712">
                            Pending
                          </th>
                          <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1713">
                            Delayed
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-1714">
                        <tr data-id="element-1715">
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1716">
                            Finance Committee
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1717">24</td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1718">
                            <div className="flex items-center" data-id="element-1719">
                              <CheckCircle size={14} className="text-green-500 mr-1" data-id="element-1720" />
                              <span data-id="element-1721">18 (75%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1722">
                            <div className="flex items-center" data-id="element-1723">
                              <Clock size={14} className="text-orange-500 mr-1" data-id="element-1724" />
                              <span data-id="element-1725">4 (17%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1726">
                            <div className="flex items-center" data-id="element-1727">
                              <X size={14} className="text-red-500 mr-1" data-id="element-1728" />
                              <span data-id="element-1729">2 (8%)</span>
                            </div>
                          </td>
                        </tr>
                        <tr data-id="element-1730">
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1731">
                            HR Committee
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1732">18</td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1733">
                            <div className="flex items-center" data-id="element-1734">
                              <CheckCircle size={14} className="text-green-500 mr-1" data-id="element-1735" />
                              <span data-id="element-1736">12 (67%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1737">
                            <div className="flex items-center" data-id="element-1738">
                              <Clock size={14} className="text-orange-500 mr-1" data-id="element-1739" />
                              <span data-id="element-1740">5 (28%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1741">
                            <div className="flex items-center" data-id="element-1742">
                              <X size={14} className="text-red-500 mr-1" data-id="element-1743" />
                              <span data-id="element-1744">1 (5%)</span>
                            </div>
                          </td>
                        </tr>
                        <tr data-id="element-1745">
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1746">
                            IT Committee
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1747">30</td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1748">
                            <div className="flex items-center" data-id="element-1749">
                              <CheckCircle size={14} className="text-green-500 mr-1" data-id="element-1750" />
                              <span data-id="element-1751">27 (90%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1752">
                            <div className="flex items-center" data-id="element-1753">
                              <Clock size={14} className="text-orange-500 mr-1" data-id="element-1754" />
                              <span data-id="element-1755">3 (10%)</span>
                            </div>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap" data-id="element-1756">
                            <div className="flex items-center" data-id="element-1757">
                              <X size={14} className="text-red-500 mr-1" data-id="element-1758" />
                              <span data-id="element-1759">0 (0%)</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}